'use client';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import t from 'prop-types';
import { TabHeaderInput } from './tab-header-input.component.js';
import { TabHeaderLabel } from './tab-header-label.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var p = Object.getOwnPropertySymbols(e);
        for(o = 0; o < p.length; o++)r = p[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, p = Object.keys(e);
    for(o = 0; o < p.length; o++)r = p[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
t.string.isRequired, t.object, t.bool;
const TabHeader = (o)=>{
    let { children: c, inputProps: i = {}, tabId: b, disabled: s = false } = o, a = _object_without_properties(o, [
        "children",
        "inputProps",
        "tabId",
        "disabled"
    ]);
    return jsxs(Fragment, {
        children: [
            jsx(TabHeaderInput, _object_spread({
                tabId: b,
                disabled: !!s
            }, i)),
            jsx(TabHeaderLabel, _object_spread_props(_object_spread({
                tabId: b
            }, a), {
                children: c
            }))
        ]
    });
};

export { TabHeader };
